exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main[data-v-080fa5d6]{max-width:800px;margin:0 auto;margin-top:20px}.cr-bottom-button[data-v-080fa5d6]{position:fixed;left:-20px;right:0;bottom:0;width:calc(100% + 220px)}\n", ""]);

// exports
